// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1KtVO","right":"styles_right__10y2M"};